




















import {Component, Vue} from 'vue-property-decorator';
import {CustomerDto} from '@/dto/CustomerDto';
import {Customer} from '@/entity/Customer';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {AuthTokenDto} from '@/oauth/AuthTokenDto';

@Component({
  components: {},
})
export default class ShenHe extends Vue {

  private customers: Customer[] = [];

  async getAllUnReview() {
    const customers = await CustomerDto.findAll(new Customer());
    this.customers = customers.filter(value => value.isReviewPass !== true);
  }

  async shenHe(c: Customer, b: boolean) {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      c.isReviewPass = b;
      await CustomerDto.review(c);
      await AuthTokenDto.getTokenByRefreshToken();
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    }
    await this.getAllUnReview();
  }

  private mounted() {
    if (!SecurityUtils.getLoginUser().hasRole('ADMIN')) {
      this.$q.notify('你没有权限使用');
      this.$router.replace('/');
    }
    this.getAllUnReview();
    return;
  }
}
